/**
 * state.js
 * Estado global de la aplicación.
 * Módulo único que contiene y gestiona todos los datos
 * que la app necesita recordar durante su ejecución.
 *
 * Patrón: módulo singleton con getters y setters.
 * Nadie modifica el estado directamente — solo a través
 * de las funciones exportadas aquí.
 */

const _estado = {
  recetas: [], // todas las recetas cargadas de Supabase
  filtradas: [], // array que se muestra en pantalla
  categoriaActiva: 'todas',
  busqueda: '',
  cargando: true,
  error: null,
};

// ── Getters ───────────────────────────────────────────

export const getRecetas = () => _estado.recetas;
export const getFiltradas = () => _estado.filtradas;
export const getCategoriaActiva = () => _estado.categoriaActiva;
export const getBusqueda = () => _estado.busqueda;
export const isCargando = () => _estado.cargando;
export const getError = () => _estado.error;

// ── Setters ───────────────────────────────────────────

export const setRecetas = (recetas) => {
  _estado.recetas = recetas;
  _estado.filtradas = recetas;
  _estado.cargando = false;
};

export const setFiltradas = (filtradas) => {
  _estado.filtradas = filtradas;
};
export const setCategoriaActiva = (categoria) => {
  _estado.categoriaActiva = categoria;
};
export const setBusqueda = (busqueda) => {
  _estado.busqueda = busqueda;
};
export const setError = (error) => {
  _estado.error = error;
  _estado.cargando = false;
};
